import min from "./min";

export default function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
}

function length(d) {
  return d.length;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-array/src/transpose.js
// module id = 64
// module chunks = 0